import React, { ReactNode } from "react"
import Image from 'next/legacy/image';
import { Layer } from "./style";
import { Indicadores } from "@/context/ranking";
interface LayerSectionProps {
  name: string

  children: ReactNode
}
export const LayerSection: React.FC<LayerSectionProps> = ({ name, children }) => {
  return <Layer>
    <Image width={25} height={25} src={Indicadores[name].img} />
    <p>{Indicadores[name].label}</p>
    {children}
  </Layer>
}
